import { useState } from 'react';
import { useAuth } from '../lib/auth';
import { T, sharedStyles } from './Shared';

// Sticky banner shown app-wide whenever the current session is an admin
// "View As" impersonation (started from the Hub). Renders nothing otherwise.
// Mirrors this app's read-only enforcement in functions/_middleware.ts —
// "Exit view" just tells the server to drop impersonating_user_id and reloads.
export function ImpersonationBanner() {
  const { user, refresh } = useAuth();
  const [exiting, setExiting] = useState(false);

  if (!user?.impersonatedBy) return null;

  const target = user.name || user.email;
  const real = user.impersonatedBy.name || user.impersonatedBy.email;

  const handleExit = async () => {
    if (exiting) return;
    setExiting(true);
    try {
      await fetch('/api/auth/impersonate', { method: 'DELETE', credentials: 'include' });
      location.reload();
    } catch {
      setExiting(false);
      void refresh();
    }
  };

  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 100,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      gap: 12, flexWrap: 'wrap',
      padding: '8px 16px',
      background: T.amber,
      color: '#fff',
      fontSize: 12, fontFamily: sharedStyles.fontBody,
    }}>
      <span>
        👁 Viewing as <strong>{target}</strong> — read-only. Real admin: {real}
      </span>
      <button
        onClick={handleExit}
        disabled={exiting}
        style={{
          background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.6)',
          color: '#fff', borderRadius: 6, padding: '3px 10px',
          cursor: exiting ? 'wait' : 'pointer',
          fontSize: 11, fontWeight: 600,
          opacity: exiting ? 0.6 : 1,
        }}
      >
        {exiting ? 'Exiting…' : 'Exit view'}
      </button>
    </div>
  );
}
